import { Sound } from './Sound';
import { SoundState } from './SoundFactory';
import { SceneObject } from './SceneObject';
import { SceneObjectType } from './SceneObjectType';
import { EventStream } from './EventStreamSubscription';

export class SoundSceneObject extends SceneObject {
  private _sound: Sound;

  constructor(sound: Sound) {
    super();
    this._sound = sound;
  }

  public get ended(): EventStream<void> {
    return this._sound.ended;
  }

  public override initialize() {
    super.initialize();
  }

  public get runtimeType(): SceneObjectType {
    return SceneObjectType.Sound;
  }

  public get volume(): number {
    return this._sound.volume;
  }

  public set volume(value: number) {
    this._sound.volume = value;
  }

  public get muted(): boolean {
    return this._sound.muted;
  }

  public set muted(value: boolean) {
    this._sound.muted = value;
  }

  public set loop(value: boolean) {
    this._sound.loop = value;
  }

  public play(): void {
    this._sound.play();
  }

  public stop(): void {
    this._sound.stop();
  }

  public initializeImpl(): void {
    this._sound.create();
  }

  public deinitializeImpl(): void {
    this._sound.destroy();
  }

  public activeChanged(active: boolean): void {
    super.activeChanged(active);
    if (!active && this._sound.state === SoundState.Playing) {
      this._sound.pause();
    }

    if (active && this._sound.state === SoundState.Paused) {
      this._sound.resume();
    }
  }
}
